import React from 'react'

export default function TrustBar() {
  return (
    <div className="bg-stone-100 py-6">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Ageras Rating */}
          <div className="py-1 text-left">
            <div className="text-sm text-stone-700">
              <span className="font-bold text-stone-900">4,76 / 5</span> baseret på <span className="font-semibold text-stone-900">153 bedømmelser</span> på Ageras
            </div>
          </div>

          {/* Experience */}
          <div className="border-l-2 border-black pl-4 py-1 text-left">
            <div className="text-sm text-stone-700">
              <span className="font-bold text-stone-900">Over 10 års erfaring</span> med små og mellemstore virksomheder
            </div>
          </div>

          {/* Personal contact */}
          <div className="border-l-2 border-black pl-4 py-1 text-left">
            <div className="text-sm text-stone-700">
              <span className="font-bold text-stone-900">Personlig kontakt</span> — du taler altid direkte med Peter
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
